import conf from './conf'

export default conf
